/* Support address lives here. Any older address left in page copy, the FAQ,
   footer or cart drawer is swapped at runtime, links included, so a
   customer can never be sent to an inbox nobody reads. */
(function(){
var NEW='support@icyfreaks.com';
var OLD=['support.pawly@gmail.com','help.littlehome@gmail.com'];
window.IF_SUPPORT_EMAIL=NEW;
function fix(root){
if(!root)return;
var links=root.querySelectorAll('a[href^="mailto:"]');
for(var i=0;i<links.length;i++){
var h=links[i].getAttribute('href')||'';
for(var k=0;k<OLD.length;k++){if(h.indexOf(OLD[k])>-1)links[i].setAttribute('href','mailto:'+NEW);}
}
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
while((n=w.nextNode())){
var t=n.nodeValue;
if(!t||t.indexOf('@')<0)continue;
var o=t;
for(var j=0;j<OLD.length;j++)t=t.split(OLD[j]).join(NEW);
if(t!==o)n.nodeValue=t;
}
}
function run(){fix(document.body);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setInterval(run,1500);
})();
